import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChildComponent } from '../case-detail.component';
import { FormDataService } from '@app/_core/services/form-data.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { AppService } from '@app/_core/services/app.service';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';

export interface Field {
  fieldType: string;
  fileAttribute: string | null;
  isAlphaNumeric: boolean;
  isEmail: boolean;
  isMobile: boolean;
  isRegex: boolean;
  isRequired: boolean;
  maxLength: number | null;
  minLength: number | null;
  pattern: string;
  value: string;
  Name: string;
  Label: string;
  fieldID: any;
  dateAttribute: any,
  fieldOptions: [],
  show: true
}

@Component({
  selector: 'app-dynamic-tab-view',
  templateUrl: './dynamic-tab-view.component.html',
  styleUrl: './dynamic-tab-view.component.scss'
})
export class DynamicTabViewComponent implements OnInit, ChildComponent {

   @Input() conf: any;
      @Output() formDataEmitter = new EventEmitter<any>();
      @Output() formDataHasError = new EventEmitter<any>();
      @Input() caseDetailsConf: any;
      @Input() tabName: any;
      @Input() ReadOnly:any;
      multiSelectFields: any = [{ fieldName: "", selectedOptions: [] }];
      isEdit: any = false;
      visible: boolean = false;
      display: any = 'none';
      field: Field = {
          fieldID: null,
          fieldType: 'Input',
          fileAttribute: null,
          isAlphaNumeric: false,
          isEmail: false,
          isMobile: false,
          isRegex: false,
          isRequired: false,
          maxLength: null,
          minLength: null,
          pattern: '',
          value: '',
          Name: '',
          Label: '',
          dateAttribute: null,
          fieldOptions: [],
          show: true
      };
  
      newField: Field = this.field;
      subheadings: any;
      modalGroupObj: any;
      formData: any = {};
      activityId: any;
      constructor(
          private cdr: ChangeDetectorRef,
          @Inject(APP_BASE_HREF) public baseHref: string,
          private formDataService: FormDataService,
          private loaderService: LoaderService,
          private queueService:QueuesService,
          private appService:AppService,
          private flexStore: FlexibleStoreService
  
      ) {
        this.appService.activityId.subscribe(value => {
          this.activityId = value;
        });
       }
  
      ngOnChanges(changes: any): void { }

      initializeFormData() {
        // Create formData model object from conf fields
        this.conf.Groups.forEach(group => {
          const groupName = group.GroupName.replaceAll(' ', '');
          if (group.IsMultiple) {
            if (group?.multipleOptions?.optionValues.length > 0) {
              group.Fields = []; // We should create fields based on group?.multipleOptions?.optionValues items and not display supplied field.
            }
    
            const groupedData = [];
            // Push existing fields in group. Update: not required
            // group.Fields.forEach((field, i) => {
            //     let obj: any = {};
            //     obj.id = field.fieldID;
            //     obj.name = field.Name;
            //     obj.value = field.value;
            //     groupedData.push(obj);
            // });
    
            //Create and push new field in conf Fields for each multipleOptions.optionValues
            group?.multipleOptions?.optionValues?.forEach(option => {
              option.items.forEach(item => {
                const obj: any = {};
                obj.id = item.id;
                obj.name = item.name;
                obj.value = item.value;
                groupedData.push(obj);
    
                const newField = {
                  fieldID: null,
                  Name: '',
                  Label: '',
                  fieldType: 'Input',
                  viewMode: true,
                  value: '',
                  fileAttribute: null,
                  isAlphaNumeric: false,
                  isEmail: false,
                  isMobile: false,
                  isRegex: false,
                  isRequired: false,
                  maxLength: null,
                  minLength: null,
                  pattern: '',
                  dateAttribute: null,
                  fieldOptions: [],
                  show: false
                };
    
                newField.fieldID = item.id;
                newField.Name = item.name;
                newField.Label = item.name;
                newField.value = item.value;
                newField.isRequired = true;
                newField.show = true;
                group.Fields.push(newField);
              });
            });
    
            this.formData[group.GroupName] = groupedData;
          } else {
            group.Fields.forEach(field => {
              this.formData[field.Name] = field.value;
              if(field.dataSource){
                this.getData(field);
                this.getChildData(field);
              }
            });
          }
        });
        // show/hide the dependent fields
        this.showAllDependentFields();
        console.log('formData', this.formData);
      }
  
      getModel(group, field) {
          let model = "";
          if (group.IsMultiple) {
              model = this.formData[group.GroupName]?.find((f: any) => f.id === field.fieldID)?.value || '';
          } else {
              model = this.formData[field.Name];
          }
          //console.log("model", field.Name, model);
          return model;
      }
  
      setModel(groupObj, fieldObj, value) {
          if (groupObj.IsMultiple) {
              let field = this.formData[groupObj.GroupName].find((f: any) => f.id === fieldObj.fieldID);
              if(field){
                  field.value = value;
              }
          } else {
              this.formData[fieldObj.Name] = value;
          }
          fieldObj.value = value;
      }
  
      ngOnInit(): void {
          this.loaderService.status.next(false);
          this.conf = this.formDataService.getConf(this.caseDetailsConf, this.tabName);
          console.log("this.conf", this.conf);
          // Load cached/existing data if available
          //console.log("this.conf.TabValue + '_conf' in sessionStorage", this.conf.TabValue + '_conf' in sessionStorage)
          // if(this.conf.TabValue + '_conf' in sessionStorage){
          //   this.conf = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf'));
          // }
          this.initializeFormData();
          this.formDataService.validateForm(this.conf, this.formDataHasError);
          if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
            this.formDataHasError.emit(true);
          }
          this.emitFormData();
      }
  
      editForm() {
          this.isEdit = !this.isEdit;
      }
  
      getFormData() {
          let formData = this.formData;
          console.log('formData', formData);
      }
  
      emitFormData() {
          this.formDataService.updateFormData(this.conf.TabValue, this.formData);
          console.log("Updated ",this.conf.TabValue, this.formData);
          this.formDataEmitter.emit(this.formData);
          //console.log("JSON.stringify(this.conf)", JSON.stringify(this.conf));
          //sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(this.conf));
          this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(this.conf));
      }
  
      addNewField(groupObj: any, optionObj: any) {
          //const group = this.conf.Groups.find(g => g.GroupName === groupObj.GroupName);
          let newField = {
              fieldID: null,
              Name: '',
              Label: '',
              fieldType: 'Input',
              value: '',
              fileAttribute: null,
              isAlphaNumeric: false,
              isEmail: false,
              isMobile: false,
              isRegex: false,
              isRequired: false,
              maxLength: null,
              minLength: null,
              pattern: '',
              dateAttribute: null,
              fieldOptions: [],
              show: true
          }
  
          newField.fieldID = this.formDataService.generateFieldID(this.conf);
          newField.Name = optionObj.name;
          newField.Label = optionObj.value;
          newField.isRequired = true;
  
          if (groupObj.IsMultiple) {
            this.formData[groupObj.GroupName].push({id: newField.fieldID, name: newField.Name, value: newField.value});
          }else{
            this.formData[newField.Name] = newField.value;
          }
  
          groupObj.Fields.push(newField);
          //groupObj.optionValues.push({name: newField.Name, value: this.formData[newField.Name]})
  
          console.log("this.formData", this.formData);
          console.log("this.conf", this.conf);
          this.emitFormData();
      }
  
      createNewField(groupObj: any, optionObj: any) {
          //const group = this.conf.Groups.find(g => g.GroupName === groupObj.GroupName);
          let newField = {
              fieldID: null,
              Name: '',
              Label: '',
              fieldType: 'Input',
              value: '',
              fileAttribute: null,
              isAlphaNumeric: false,
              isEmail: false,
              isMobile: false,
              isRegex: false,
              isRequired: false,
              maxLength: null,
              minLength: null,
              pattern: '',
              dateAttribute: null,
              fieldOptions: [],
              show: true
          }
  
          newField.fieldID = this.formDataService.generateFieldID(this.conf);
          newField.Name = optionObj.name;
          newField.Label = optionObj.value;
          newField.isRequired = true;
  
          if (groupObj.IsMultiple) {
            this.formData[groupObj.GroupName].push({id: newField.fieldID, name: newField.Name, value: newField.value});
          }else{
            this.formData[newField.Name] = newField.value;
          }
          if(groupObj.multipleOptions.optionValues[0].items.length == 1) // Fields in group 
              groupObj.Fields.push(newField);
          else{
  
          }
          //groupObj.optionValues.push({name: newField.Name, value: this.formData[newField.Name]})
  
          console.log("this.formData", this.formData);
          console.log("this.conf", this.conf);
          this.emitFormData();
      }
  
      onFormDataChange(groupObj, fieldObj, event) {
          this.setModel(groupObj, fieldObj, event.target.value);
          this.emitFormData();
          //this.formDataService.validateField(fieldObj, event.target.value, this.formDataHasError);
          this.formDataService.validateForm(this.conf, this.formDataHasError);
          if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
            this.formDataHasError.emit(true);
          }
      }

      onDropDownChange(groupObj, fieldObj, event) {
        let selectedValue =  event.target.value;
        console.log("onDropDownChange", selectedValue)
        this.setModel(groupObj, fieldObj, selectedValue);
        this.emitFormData();
        //this.formDataService.validateField(fieldObj, event.target.value, this.formDataHasError);
        this.formDataService.validateForm(this.conf, this.formDataHasError);
        if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
            this.formDataHasError.emit(true);
        }
    
        // show/hide dependent fields
        this.showAllDependentFields();
    
        if(fieldObj.childDataSource){
            this.getChildData(fieldObj);
        }
        if(fieldObj.childSourceFromAdmin)
        {
           this.getChildDataFromConfiguration(fieldObj);
        }
      }
  
      openModal(group) {
          this.modalGroupObj = group;
          console.log("group", group);
          this.display = 'block';
      }
  
      onCloseHandled(group) {
          this.display = 'none';
          this.reset(group);
      }
  
      onMultipleOptionChange(selectedOption, group) {
          group.multipleOptions.options.forEach(option => {
              if (option.name === selectedOption.name) {
                  option.Selected = !option.Selected;
              }
          })
      }
  
      onAddMultipleOption(group) {
          group.multipleOptions.options.forEach(element => {
              if (element.Selected) {
                  this.addNewField(group, element);
              }
          });
          this.onCloseHandled(group);
      }
  
      reset(group) {
          group.multipleOptions.options.forEach(option => {
              option.Selected = false;
          })
      }
  
      showDialog() {
          this.visible = true;
      }
  
      addNewFieldGroup(group){
          let fieldGroup = [];
          if(group.multipleOptions.length > 0 ){
              group.multipleOptions.optionValues[0].items.forEach((item, index) => {
                  let newField = {
                      fieldID: null,
                      Name: '',
                      Label: '',
                      fieldType: 'Input',
                      value: '',
                      fileAttribute: null,
                      isAlphaNumeric: false,
                      isEmail: false,
                      isMobile: false,
                      isRegex: false,
                      isRequired: false,
                      maxLength: null,
                      minLength: null,
                      pattern: '',
                      dateAttribute: null,
                      fieldOptions: [],
                      show: true
                  }
          
                  newField.fieldID = this.formDataService.generateFieldID(this.conf) + index + 1;
                  newField.Name = item.name;
                  newField.Label = item.name;
                  newField.isRequired = true;
                  fieldGroup.push(newField);
              })
              console.log("fieldGroup", fieldGroup);
              group.Fields.push(fieldGroup);
          }
         
        
     }

      onCheckboxChange(e: any, field: any, group: any) {
        if (!this.fieldExist(field.Name)) {
          this.multiSelectFields.push({ fieldName: field.Name, selectedOptions: [] })
        }
        this.multiSelectFields.forEach(obj => {
          if(obj.fieldName === field.Name){
            console.log("selectedOptions", obj.selectedOptions);
            if (e.target.checked) {
              obj.selectedOptions.push(e.target.value);
            } else {
              let index = obj.selectedOptions.indexOf(e.target.value);
              if (index > -1) {
                obj.selectedOptions.splice(index, 1);
              }
            }
          // Update dynamicForm
            this.setModel(group, field, obj.selectedOptions)
            // Update field value in conf obj, this will help in retaining newly checked option while navigating between tabs
            field.value = obj.selectedOptions; 
          }
        })
      }

      setCheckBoxGroupDefaultValues(){
        this.conf.Groups.forEach(group => {
          group.Fields.forEach(field => {
            if(field.fieldType === "CheckBoxGroup"){
              if (!this.fieldExist(field.Name)) {
                this.multiSelectFields.push({ fieldName: field.Name, selectedOptions: [] })
              }
              this.setModel(group, field, field.value)
              this.multiSelectFields.forEach(obj => {
                if(obj.fieldName === field.Name){
                  console.log("selectedOptions", obj.selectedOptions);
                  obj.selectedOptions.push(field.value);
                  this.setModel(group, field, obj.selectedOptions)
                }
              })
            }
          })
        })
      }

      fieldExist(fieldName: string) {
        let exist = false;
        this.multiSelectFields.forEach(obj => {
          if (obj.fieldName === fieldName) {
            exist = true;
          }
        })
        return exist;
      }

      getSelectedOption(field, value){
        let targetOption: any = {};
        field.fieldOptions.forEach(option => {
          if(option.Value == value){
            targetOption = option;
          }
        })
        return targetOption;
      }

      showAllDependentFields(){
        this.conf.Groups.forEach(group => {
          group.Fields.forEach(field => {
            field.show = true;
            if(field.parent && field.parentFieldOption){ // Is dependent
              field.show = false;
              field.parent.parentFields.forEach(item => {
                let parentField: any = this.getFieldByID(item.fieldID);
                let selectedOption = this.getSelectedOption(parentField, parentField.value);
                //To which option the field is dependent?
                let depends = false;
                field?.parentFieldOption?.parentFieldOption.forEach(item => {
                  if(item.fieldOptionID == selectedOption.FieldOptionID){
                    depends = true;
                    console.log(field.Name + " is dependent on " + parentField.Name +" : "+ parentField.value);
                  }
                })
                if(depends){
                  field.show = true;
                }
              })
            }
          })
        })
        console.log('showAllDependentFields - conf', this.conf);
      }
    
      getData(fieldObj){
        this.formDataService.getData(fieldObj.dataSource).subscribe(response => {
            //console.log("getData response", response.Response.Data);
            fieldObj.fieldOptions = response.Response.Data;
        });
      }
    
      getChildData(fieldObj){
        let childFieldID = fieldObj.children.childFields[0].fieldID;
        let childField: any = this.getFieldByID(childFieldID);
        childField.fieldOptions = [];
        if(fieldObj.value){
          this.formDataService.getData(fieldObj.childDataSource + fieldObj.value).subscribe(response => {
            console.log("getData response", response.Response.Data);
            childField.fieldOptions = response.Response.Data;
        })
        }
      }
    
      getFieldByID(fieldID){
        let targetField = {};
        this.conf.Groups.forEach(group => {
            group.Fields.forEach(field => {
                if(fieldID == field.fieldID){
                    targetField = field;
                }
            })
        })
        return targetField;
      }
      getChildDataFromConfiguration(fieldObj) {
        let childFieldID = fieldObj.children.childFields[0].fieldID;
        let childField: any = this.getFieldByID(childFieldID);
        childField.fieldOptions = [];
        if (fieldObj.value) {
          let payload={
            queueID:this.queueService.getselectedQueueId(),
            activityID:this.activityId,
            fieldID:fieldObj.fieldID,
            fieldName:fieldObj.Name,
            parentValue:fieldObj.value,
            type:"TMCaseDetail"
          }
          this.queueService.getDependantDataSource(payload).subscribe(response => {
               childField.fieldOptions = response.Response.Data;
          });
        }
      }
}
